import styled from "styled-components";

export const StyledLanguageSelect = styled.div`
  .lang-select {
    width: 100%;
    color: ${({theme}) => theme.text.primary};
    font-size: 18px;
    font-weight: 600;
    position: relative;
    z-index: 1;
    &:after {
      display: none;
    }
    &:before {
      content: "\\e90d";
      font-size: 12px;
      font-family: "cp-icons", sans-serif;
      border: none !important;
      position: absolute;
      left: auto;
      top: 6px;
      right: 5px;
    }
    &__pref {
      text-transform: uppercase;
    }
    &__text {
      display: none;
    }
    .MuiSelect-select {
      padding: 5px 10px 5px 5px;
    }
    svg {
      display: none;
    }
    @media screen and (max-width: 599px) {
      font-size: 14px;
      .MuiSelect-select {
        padding: 5px;
      }
      &:before {
        display: none;
      }
  }
`;